import styled, {css} from "styled-components";
import { defaultTheme } from "../../data/themes";

/*
		background: #3A3A3A;
		color: #ffffff;

*/
const PSInput = styled.input`
	background: ${props => props.theme.inputBackground ?? defaultTheme.inputBackground};
	color: ${props => props.theme.inputColor ?? defaultTheme.inputColor};
	border: ${props => props.theme.inputBorder ?? defaultTheme.inputBorder};
	border-radius: ${props => props.theme.inputBorderRadius ?? defaultTheme.inputBorderRadius};
	outline: ${props => props.theme.inputOutline ?? defaultTheme.inputOutline};
	font-weight: ${props => props.theme.inputFontWeight ?? defaultTheme.inputFontWeight};
	font-size: ${props => props.theme.inputFontSize ?? defaultTheme.inputFontSize};
	padding: ${props => props.theme.inputPadding ?? defaultTheme.inputPadding};
	text-align: ${props => props.textAlign};

	&::selection {
		background: ${props => props.theme.inputSelectionBackground ?? defaultTheme.inputSelectionBackground};
		color: ${props => props.theme.inputSelectionColor ?? defaultTheme.inputSelectionColor};
	}

	&[readonly] {
		background: ${props => props.theme.inputReadOnlyBackground ?? defaultTheme.inputReadOnlyBackground};
		color: ${props => props.theme.inputReadOnlyColor ?? defaultTheme.inputReadOnlyColor};
	}

	::placeholder {
		text-align: left;
		color: ${props => props.theme.inputPlaceholderColor ?? defaultTheme.inputPlaceholderColor};
		font-weight: ${props => props.theme.inputPlaceHolderFontWeight ?? defaultTheme.inputPlaceHolderFontWeight};
	}

`;


export default PSInput;

